export default __webpack_public_path__ + "static/media/balance-evals-adjust.40bf5da4.md";